export const CHART_TYPES = {
  LINE: 'influx.line',
  CAMERA_BASED_LINE: 'influx.cameraBasedLine',
  REGIONS: 'influx.regions',
  REGION_SUMS: 'influx.regionSums',
  IR: 'influx.ir',
  INCIDENT_BAR: 'database.entries.incident.barchart',
  DATABASE_ENTRIES_BAR: 'database.entries.barchart',
} as const

export type ChartType = (typeof CHART_TYPES)[keyof typeof CHART_TYPES]

export const TIME_SERIES_CHART_TYPES = [
  CHART_TYPES.LINE,
  CHART_TYPES.CAMERA_BASED_LINE,
  CHART_TYPES.REGIONS,
  CHART_TYPES.REGION_SUMS,
  CHART_TYPES.IR,
  CHART_TYPES.INCIDENT_BAR,
  CHART_TYPES.DATABASE_ENTRIES_BAR,
]
